import React from "react";
import * as Styles from "./styles/VehicleDetails";
import * as Form from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import * as FormsAem from "../common/styles/FormsAem";
import type { TradeInAemDetailFormItem } from "../../../utils/types";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { useTradeInAemLabel } from "../../../utils/labels";
import { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";

type Props = { formItem: TradeInAemDetailFormItem; formItemKey: string; showRequiredError?: boolean };

const VehicleDetailsRadioButton = ({ formItemKey, showRequiredError, formItem }: Props): JSX.Element | null => {
    const csl = useTradeInCsl();
    const requiredLabel = useTradeInAemLabel("tradeInAemFieldRequired");
    const { label, options = [], value, required } = formItem;

    return (
        <Styles.RadioGroup>
            <Styles.RadioGroupTitle>
                {label}
                {required && <FormsAem.MandatoryField largeFontSize>*</FormsAem.MandatoryField>}
            </Styles.RadioGroupTitle>
            {options.map((option) => {
                return (
                    <Form.Check
                        key={`${option.value}-${String(value === option.value)}`}
                        hasDescription={!!option.description}
                    >
                        <input
                            type="radio"
                            id={`${formItemKey}-${option.value}`}
                            name={`${formItemKey}-${option.value}`}
                            checked={value === option.value}
                            onChange={(event) => {
                                if (event.target.checked) {
                                    csl.setFormItemValue(formItemKey, option.value);
                                }
                            }}
                        />
                        <label htmlFor={`${formItemKey}-${option.value}`}>
                            <Form.LabelTitle>{option.label}</Form.LabelTitle>
                            {!!option.description && <div>{option.description}</div>}
                        </label>
                    </Form.Check>
                );
            })}
            {!!showRequiredError && !value && (
                <FormsAem.Error>
                    <span>{requiredLabel}</span>
                    <IconWrapper iconColor="primaryRed">
                        <IconExclamation />
                    </IconWrapper>
                </FormsAem.Error>
            )}
        </Styles.RadioGroup>
    );
};

export default VehicleDetailsRadioButton;
